import { GetServerSidePropsContext } from "next"
import { destroyCookie, parseCookies } from "nookies"
import jwt from "jsonwebtoken"
import { JWT_SECRET, TOKEN_COOKIES } from "@const/shared"

export function serverTokenChecker(ctx: GetServerSidePropsContext): string | null {
  const parsedCookies = parseCookies(ctx)
  const token = parsedCookies.HSTOKENID

  if (!token) {
    return null
  }

  jwt.verify(token, JWT_SECRET, (err) => {
    if (err) {
      destroyCookie(ctx, TOKEN_COOKIES, {})
      return null
    }
  })

  return token
}
